import $ from 'jquery'
import jQuery from 'jquery';
import 'jquery-ui';

class inViewport{
    constructor(obj) {
        const { element, threshold, cls, trigger} = obj;
        if (!element) return

        this.element =  $(element)       
        this.threshold = threshold
        this.cls = cls
        this.trigger = trigger
       // var section = this.element;
      
        $(document).on("window-loaded", () => {
            this.isOnScreen();
        });

        this.isOnScreen();
   
        this.scrolling = false;
        this.scrolltimer = 0;

        $(window).on("scroll", () => {
            this.scrolling = true;
            clearTimeout(this.scrolltimer);
            this.scrolltimer = setTimeout(() => {
                this.isOnScreen();
            }, 300);
        });

        $(window).on("resize", () =>{
            setTimeout(() => {
                this.isOnScreen();
            }, 300);
        });      
    }

    isOnScreen() {
        var plgn = this;
      //  var section = this.element;      //this.section = $(this.element)

        var win = $(window);

        this.element.onScreenCls = !this.element.onScreenCls ? this.cls : this.element.onScreenCls;

        var viewport = {
            top: win.scrollTop(),
            left: win.scrollLeft(),
        };

        viewport.right = viewport.left + win.width();
        viewport.bottom = viewport.top + win.height();
     
        var bounds =  this.element.offset();

        bounds.right = bounds.left +  this.element.outerWidth();
        bounds.bottom = bounds.top +  this.element.outerHeight();

        var headeroffset = 0;
        if ($(".header__layer").length) {
            headeroffset = $(".header__layer").outerHeight();
        }

        var offset = headeroffset + this.threshold;

        if (
            !(
                viewport.right < bounds.left ||
                viewport.left > bounds.right ||
                viewport.bottom < bounds.top + offset ||
                viewport.top > bounds.bottom - offset
            )
        ) {
            this.element.addClass( this.element.onScreenCls);
            this.element.addClass("onScreenOnce");

            if (typeof this.trigger === 'function') 
            this.trigger("onScreen", null, { item:  this.element });
        } else {
            this.element.removeClass( this.element.onScreenCls);
            if (typeof this.trigger === 'function') 
            this.trigger("onScreen", null, { item:  this.element });
            // plgn._trigger("offScreen", null, { item:  this.element });
        }
    }
    
}
export default inViewport
